/**
*
* Disclaimer: Source code mentioned below is(are) Intellectual Property of
* Crayon Data Holdings Limited (including its subsidiaries and affiliates).
* Crayon Data Holdings Limited reserves right to own and control it the way
* it may deem fit. You must refrain from use, access, read, modify, add or
* delete, sell or use in any other package or programme pertaining to such
* source code without explicit prior written approval of
* Crayon Data Holding Limited. Breach of the same shall attract penalty as
* applicable.
*
*/

// Rating
import React from "react";

export const WithRatingStar = ({ rating }) => {
  return (
    <div className="theme-search-results-item-rating p-abs-rating">
      <ul className="theme-search-results-item-rating-stars">
        {[...new Array(parseInt(rating))].map(() => {
          return (
            <li className="active">
              <i className="fa fa-star"></i>
            </li>
          );
        })}
        {parseFloat(rating) - parseInt(rating) > 0 && (
          <li className="active">
            <i className="fa fa-star-half-o"></i>
          </li>
        )}
      </ul>
    </div>
  );
};

export const WithoutRatingStar = () => {
  return (
    <div className="theme-search-results-item-rating p-abs-rating">
      <p>{`No Star Rating Available`}</p>
    </div>
  );
};
